/* This file is auto-generated by the iconsToCSS module; do not edit */

export type SaIconsType =
  | 'listen-line-small-art'
  | 'mobile-small-art'
  | 'other-platforms-small-art'
  | 'smart-tv-small-art'
  | 'apple-brands'
  | 'dropbox-brands'
  | 'facebook-brands'
  | 'google-podcasts-brands'
  | 'markdown-brands'
  | 'sa-icon-centered-brands'
  | 'sa-icon-circle-brands'
  | 'spotify-brands'
  | 'stitcher-brands'
  | 'tunein-brands'
  | 'twitter-brands'
  | 'vault-icon-brands'
  | 'x-twitter-brands'
  | 'youtube-brands'
  | 'audio-book-categories'
  | 'bible-study-categories'
  | 'calendar-categories'
  | 'campground-categories'
  | 'cassette-categories'
  | 'chalkboard-teacher-categories'
  | 'child-categories'
  | 'church-categories'
  | 'coffee-categories'
  | 'comment-question-categories'
  | 'comments-categories'
  | 'cut-categories'
  | 'debate-categories'
  | 'disc-drive-categories'
  | 'flower-tulip-categories'
  | 'graduation-cap-categories'
  | 'newspaper-categories'
  | 'podcast-categories'
  | 'podium-categories'
  | 'praying-hands-categories'
  | 'radio-event-categories'
  | 'rings-wedding-categories'
  | 'smile-categories'
  | 'star-categories'
  | 'sun-categories'
  | 'sunrise-categories'
  | 'sunset-categories'
  | 'tv-categories'
  | 'user-chat-categories'
  | 'users-categories'
  | 'pin-colored'
  | 'speaker-blank-colored'
  | 'user-blank-colored'
  | 'album-collection'
  | 'align-left'
  | 'angle-down'
  | 'angle-left'
  | 'angle-right'
  | 'angle-up'
  | 'arrow-indent'
  | 'arrow-left'
  | 'arrow-right'
  | 'badge-check'
  | 'bible'
  | 'bold'
  | 'book'
  | 'bookmark'
  | 'broadcast'
  | 'calendar'
  | 'chart-line'
  | 'check'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'church-user'
  | 'church'
  | 'clock'
  | 'close'
  | 'closed-captioning'
  | 'code'
  | 'cog'
  | 'comment'
  | 'copy'
  | 'credit-card-front'
  | 'cube'
  | 'devotional'
  | 'door-exit'
  | 'download'
  | 'ellipsis-circle'
  | 'ellipsis-h'
  | 'email'
  | 'error'
  | 'exclamation-circle'
  | 'exclamation-triangle'
  | 'eye-slash'
  | 'eye'
  | 'file-alt'
  | 'file-pdf'
  | 'file-word'
  | 'film'
  | 'filter'
  | 'flip-horizontal'
  | 'flip-vertical'
  | 'fullscreen-exit'
  | 'fullscreen'
  | 'gift'
  | 'globe-europe'
  | 'globe'
  | 'graduation-cap'
  | 'grid-2'
  | 'grid'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'hand-pointer'
  | 'hashtag'
  | 'history'
  | 'home'
  | 'hymnal-open'
  | 'hymnal'
  | 'image'
  | 'inbox'
  | 'italic'
  | 'key'
  | 'keyboard'
  | 'language'
  | 'legacy'
  | 'lightbulb-exclamation'
  | 'lightbulb-on'
  | 'lightbulb-slash'
  | 'lightbulb'
  | 'link'
  | 'list-ol'
  | 'list-ul'
  | 'magic'
  | 'map-marker-alt'
  | 'map'
  | 'megaphone'
  | 'microphone-alt'
  | 'microphone-plus'
  | 'microphone'
  | 'minus-circle'
  | 'music'
  | 'newspaper'
  | 'paragraph'
  | 'password'
  | 'pencil'
  | 'phone'
  | 'play'
  | 'playlist'
  | 'plus-circle'
  | 'plus'
  | 'podcast'
  | 'podium'
  | 'pop-out'
  | 'print'
  | 'question-circle'
  | 'radio'
  | 'redo'
  | 'remove-format'
  | 'repeat'
  | 'rotate-ccw'
  | 'rotate-cw'
  | 'rss'
  | 'search-text'
  | 'search'
  | 'share-alt'
  | 'share'
  | 'sign-in'
  | 'sign-out'
  | 'sitemap'
  | 'skip-backward-5'
  | 'skip-backward'
  | 'skip-forward-5'
  | 'skip-forward'
  | 'sliders'
  | 'speaker'
  | 'star'
  | 'step-forward'
  | 'sticky-note'
  | 'sync'
  | 'tag'
  | 'thumb-list'
  | 'thumbtack'
  | 'times-octagon'
  | 'tools'
  | 'transcript'
  | 'trash-alt'
  | 'tutor'
  | 'underline'
  | 'undo'
  | 'university'
  | 'upload'
  | 'usa'
  | 'user'
  | 'users'
  | 'vault-ai'
  | 'volume-slash'
  | 'volume'
  | 'waveform'
  | 'check-regular'
  | 'close-regular'
  | 'airplay-audio-solid'
  | 'airplay-video-solid'
  | 'bars-solid'
  | 'beta-solid'
  | 'bookmark-solid'
  | 'camera-solid'
  | 'church-user-solid'
  | 'comment-solid'
  | 'copy-solid'
  | 'email-solid'
  | 'exclamation-square-solid'
  | 'folder-upload-solid'
  | 'grip-vertical-solid'
  | 'lightbulb-on-solid'
  | 'logo-full-opacity-solid'
  | 'logo-min-solid'
  | 'logo-solid'
  | 'map-marker-alt-solid'
  | 'map-marker-solid'
  | 'map-solid'
  | 'pause-solid'
  | 'play-solid'
  | 'qrcode-solid'
  | 'quote-left-solid'
  | 'redo-solid'
  | 'share-alt-solid'
  | 'thumbtack-solid'
  | 'user-solid'

export const SaIconsFolder = [
  'art',
  'brands',
  'categories',
  'colored',
  'light',
  'regular',
  'solid',
]
